import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ViewListIcon from '@material-ui/icons/ViewList';

export default {
  board: {
    limit: 9,
    icon: <ViewListIcon fontSize="small" />,
    label: 'Table',
  },
  table: {
    limit: 5,
    icon: <ViewModuleIcon fontSize="small" />,
    label: 'Board',
  },
};
